<div class="order-price-input">
	<div class="title-wrapper">
		<p class="title">{{ label() | translate }}</p>
		@if (bidPrice() && askPrice()) {
			<span class="bid-ask-wrapper">
				<span
					class="bid"
					[tuiSkeleton]="isLoading()"
				>
					<span class="label">{{ 'orderPriceInput.bid' | translate }}</span>
					<span class="value">{{ bidPrice() | price }}</span>
				</span>
				<div class="circle"></div>
				<span
					class="ask"
					[tuiSkeleton]="isLoading()"
				>
					<span class="label">{{ 'orderPriceInput.ask' | translate }}</span>
					<span class="value">{{ askPrice() | price }}</span>
				</span>
			</span>
		}
	</div>
	<label
		class="input-label"
		tuiLabel
	>
		<tui-textfield
			[iconStart]="icon()"
			tuiTextfieldSize="s"
			[tuiTextfieldCleaner]="true"
		>
			<input
				tuiInputNumber
				inputNumberSigns
				[formControl]="formControl()"
				[tuiNumberFormat]="{ decimalSeparator: ',', thousandSeparator: ' ', rounding: 'round' }"
				[step]="step()"
				[min]="0"
				placeholder="0"
			/>
		</tui-textfield>
	</label>
</div>
